import { mapState, mapGetters, mapActions } from 'vuex'

export const widgetActions = mapActions('widgets', [
  'commitWidgetData',
  'commitWidgetChanges',
  'commitUser',
  'commitParams',
  'commitQuery',
])
export const zendeskActions = mapActions('zendesk', [
  'createTicket',
  'createTicketForChat',
  'getFirebaseDatabases',
  'getTicketStatus',
  'getTicketsWithourOrderId',
  'uploadFile',
  'commitCustomField',
  'commitTicketUpdate',
  'commitZendeskCommon',
  'addZendeskAttachment',
  'removeZendeskAttachment',
  'addAttachmentFile',
  'commitRequiredFields',
  'getTicketsByOrder',
  'setGuestArticle',
])

export const firebaseActions = mapActions('firebaseData', [
  'getFirebaseDatabaseURLS',
  'initializeFirebase'
])

export const zendeskValidateActions = mapActions('zendesk', [
  'commitValidatedField',
  'removeValidatedField',
  'resetZendeskState',
])

export const countryDataActions = mapActions('countryData', [
  'commitCountryData',
  'commitSupportOption',
])

export const computedEnv = {
  ...mapGetters('widgets', ['userEnv']),
}

export const authComputed = {
  ...mapState('widgets', {
    user: state => state.common.user,
  }),
  ...mapGetters('widgets', ['userEnv']),
}

export const arrayUniqueByKey = (array, key) => {
  let a = array.concat()
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i][key] === a[j][key]) a.splice(j--, 1)
    }
  }
  return a
}

export const onlyUnique = (v, r, key) => {
  if (!r.length) return v.concat(r)
  return r.filter(o => {
    return !v.find(o2 => o[key] === o2[key])
  })
}

export const inArray = (array, comparer) => {
  for (let i = 0; i < array.length; i++) {
    if (comparer(array[i])) return true
  }
  return false
}

export const pushIfNotExist = (array, element, comparer) => {
  if (!inArray(array, comparer)) {
    array.push(element)
  }
}

export const capitalize = ([s, ...tring]) => {
  return [s.toUpperCase(), ...tring].join('')
}
